import React from 'react';
import { FormatDate, FormatDateTime, FormatUniversalDateTime } from '../../utils/common';
import { useShowTime } from '../ShowTimeContext';

export const DateFormatter = (props: { value?: string | Date, style?: React.CSSProperties }) =>
    props.value ? <div style={props.style}>{ FormatDate(props.value)}</div> : null;
export const DateTimeFormatter = (props: { value?: string | Date, style?: React.CSSProperties }) =>
    props.value ? <div style={props.style}>{FormatDateTime(props.value, true)}</div> : null;
export const UniversalDateTimeFormatter = (props: { value?: string | Date, style?: React.CSSProperties }) => {
    const showTime = useShowTime();
    return props.value ? <div style={props.style}>{FormatUniversalDateTime(props.value, showTime)}</div> : null;
};